var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCheckboxCircleLine = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33317 10.0001C3.33317 6.31818 6.31794 3.33341 9.99984 3.33341C13.6818 3.33341 16.6665 6.31818 16.6665 10.0001C16.6665 13.682 13.6818 16.6667 9.99984 16.6667C6.31794 16.6667 3.33317 13.682 3.33317 10.0001ZM9.99984 1.66675C5.39746 1.66675 1.6665 5.39771 1.6665 10.0001C1.6665 14.6024 5.39746 18.3334 9.99984 18.3334C14.6022 18.3334 18.3332 14.6024 18.3332 10.0001C18.3332 5.39771 14.6022 1.66675 9.99984 1.66675ZM14.5474 7.88101L13.3689 6.70249L9.1665 10.9049L6.8391 8.5775L5.66058 9.756L9.1665 13.2619L14.5474 7.88101Z",
    fill: "#4C5552"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCheckboxCircleLine, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/checkbox-circle-line.1ad0311c.svg";
export { ForwardRef as ReactComponent };